import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/tables/data/authorsTableData"; // Ensure this path is correct
import { Button, Modal, MenuItem } from "@mui/material"; // Using Material UI components
import MDInput from "components/MDInput"; // Ensure you have MDInput component imported
import MDButton from "components/MDButton";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { format, addDays } from "date-fns";

// const formatDate = (date) => date.toISOString().split("T")[0];
const formatDate = (date) => format(date, "yyyy-MM-dd", { timeZone: "Africa/Cairo" });

// Utility function to convert files to Base64
const convertFilesToBase64 = (files) => {
  return Promise.all(
    Array.from(files).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve({ name: file.name, content: reader.result.split(",")[1] });
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    })
  );
};

function Tables() {
  const { columns, createRowsFromData } = authorsTableData;
  const [rows, setRows] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const tokens = JSON.parse(localStorage.getItem("authTokens"));
  const access_token = tokens?.access;

  const [selectedMessage, setSelectedMessage] = useState(null);
  const [show, setShow] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryStatus, setCategoryStatus] = useState("loading");

  const [channelsstats, setChannelsStats] = useState([]);
  const [channelstatsStatus, setchannelstatsStatus] = useState("loading");

  const [channels, setChannels] = useState([]);
  const [channelStatus, setChannelStatus] = useState("loading");

  const getEgyptDate = () => {
    const egyptDate = new Date(
      new Intl.DateTimeFormat("en-US", { timeZone: "Africa/Cairo" }).format(new Date())
    );
    return egyptDate;
  };
  const todayDate = getEgyptDate();
  const tomorrowDate = addDays(todayDate, 1);

  // console.log(todayDate);

  const [currentDate, setCurrentDate] = useState(formatDate(todayDate));
  // console.log(currentDate);

  const fetchData = () => {
    setLoading(true);
    fetch("https://teleback.info/api_admin/pups/telegrammessage/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          signOut();
          navigate("/sign-out");
        }
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        const filteredData = data
          .filter((item) => item.publish_date.startsWith(currentDate))
          .map((item, index, array) => ({
            ...item,
            counter: array.length - index,
            // Extract fields from the first message_texts object
            text: item.message_texts?.[0]?.text || "",
            discount: item.message_texts?.[0]?.discount || "",
            deal_price: item.message_texts?.[0]?.deal_price || "",
            link: item.message_texts?.[0]?.link || "",
            currency: item.message_texts?.[0]?.currency || "",
            sub_id: item.message_texts?.[0]?.sub_id || "",
            ...(item.message_type === "singleproduct" && {
              regular_price: item.regular_price || "",
            }),
          }));
        if (filteredData.length > 0) {
          setRows(createRowsFromData(filteredData, handleShow));
          setErrorMessage("");
        } else {
          setErrorMessage("No messages yet.");
          setRows([]);
        }
      })
      .catch(() => {
        setErrorMessage("Failed to retrieve data.");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, [currentDate]);

  useEffect(() => {
    const fetchCategories = async () => {
      const apiUrl = "https://teleback.info/api_admin/pups/category/list/";
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        });
        if (response.status === 401) {
          signOut();
          navigate("/sign-out");
        }
        const data = await response.json();
        if (data.length === 0) {
          setCategoryStatus("empty");
        } else {
          setCategories(data);
          setCategoryStatus("loaded");
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategoryStatus("error");
      }
    };
    const fetchChannels = async () => {
      const apiUrl = "https://teleback.info/api_admin/pups/telegramchannels/";
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        });
        if (response.status === 401) {
          signOut();
          navigate("/sign-out");
        }
        const data = await response.json();
        setChannels(data["data"] || []);
        setChannelsStats(data["channels_stats"] || []);
        setChannelStatus(data["data"]?.length ? "loaded" : "empty");
        setchannelstatsStatus(data["channels_stats"]?.length ? "loaded" : "empty");
      } catch (error) {
        console.error("Error fetching Channels:", error);
        setChannelStatus("error");
      }
    };
    fetchChannels();
    fetchCategories();
  }, [access_token]);

  const handleShow = (message) => {
    setSelectedMessage(message);
    setShow(true);
  };

  const handleClose = () => {
    setSelectedMessage(null);
    setShow(false);
  };

  const handleNextDay = () => {
    setCurrentDate(formatDate(tomorrowDate));
  };

  const handlePreviousDay = () => {
    setCurrentDate(formatDate(todayDate));
  };

  const handleUpdateProduct = async () => {
    try {
      const response = await fetch(
        `https://teleback.info/api_admin/pups/telegrammessage/${selectedMessage.id}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
          body: JSON.stringify(selectedMessage),
        }
      );
      if (response.status === 401) {
        signOut();
        navigate("/sign-out");
      }
      if (response.ok) {
        // alert("Product updated successfully!");
        handleClose();
        fetchData();
      } else {
        const errorData = await response.json();
        const fieldErrors = Object.entries(errorData)
          .map(
            ([field, messages]) =>
              `${field}: ${Array.isArray(messages) ? messages.join(", ") : messages}`
          )
          .join("\n");
        alert(`Failed to update product:\n${fieldErrors}`);
      }
    } catch (error) {
      console.error("Error updating product:", error);
      alert("An unexpected error occurred. Please try again later.");
    }
  };

  const handleDeleteProduct = async (id) => {
    try {
      const response = await fetch(`https://teleback.info/api_admin/pups/telegrammessage/${id}/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });
      if (response.status === 401) {
        signOut();
        navigate("/sign-out");
      }
      if (response.ok) {
        setRows((prevRows) => prevRows.filter((row) => row.id !== id)); // Update rows
        alert("Product deleted successfully!");
        handleClose();
        fetchData();
      } else {
        alert("Failed to delete product.");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      alert("An unexpected error occurred. Please try again later.");
    }
  };

  const handleFileChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "uploaded_files" && files.length > 0) {
      convertFilesToBase64(files).then((base64Files) => {
        setSelectedMessage((prevData) => ({
          ...prevData,
          uploaded_files: base64Files, // Store only Base64 content
        }));
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3} mt={2}>
        {channelstatsStatus === "loading" ? (
          <MenuItem disabled>Loading...</MenuItem>
        ) : channelstatsStatus === "empty" ? (
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="leaderboard"
                title="No Channels"
                count=""
                percentage={{
                  color: "error",
                  amount: "Contact Admin For Support",
                  label: "",
                }}
              />
            </MDBox>
          </Grid>
        ) : (
          channelsstats.map((channel) => (
            <Grid item xs={12} md={6} lg={3} key={channel.id}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color={
                    channel.remaining_state === "no_messages"
                      ? "error"
                      : channel.remaining_state === true
                      ? "info"
                      : "success"
                  }
                  icon="leaderboard"
                  title={channel.name}
                  count={`${channel.messages_count}/${channel.target}`}
                  time={{
                    color: channel.time_state ? "success" : "error",
                    amount: channel.time,
                    label: channel.time_symbol,
                  }}
                  penalties={{
                    color: channel.penalties === 0 ? "success" : "error",
                    amount: channel.penalties,
                    label: "Penalities",
                  }}
                  percentage={{
                    color: channel.remaining_state ? "primary" : "success",
                    amount: channel.remaining,
                    label: "Remaining Messages",
                  }}
                />
              </MDBox>
            </Grid>
          ))
        )}
      </Grid>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} mt={2}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    {currentDate === formatDate(todayDate) ? "Today Messages" : "Tomorrow Messages"}
                  </MDTypography>

                  <MDBox mt={4} mb={1}>
                    <Grid container spacing={2} justifyContent="space-between">
                      {currentDate !== formatDate(todayDate) && (
                        <IconButton size="small" disableRipple onClick={handlePreviousDay}>
                          <KeyboardDoubleArrowLeftIcon />
                        </IconButton>
                      )}
                      <MDTypography variant="h6" color="white">
                        {currentDate}
                      </MDTypography>
                      {currentDate !== formatDate(tomorrowDate) && (
                        <IconButton size="small" disableRipple onClick={handleNextDay}>
                          <KeyboardDoubleArrowRightIcon />
                        </IconButton>
                      )}
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox pt={3} align="center">
                {loading ? (
                  <MDTypography variant="h6" color="white">
                    Loading...
                  </MDTypography>
                ) : errorMessage ? (
                  <MDTypography variant="h6" color="red">
                    {errorMessage}
                  </MDTypography>
                ) : (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <Modal open={show} onClose={handleClose}>
        <Grid container justifyContent="center" spacing={0}>
          <Grid item xs={12} md={8} lg={6}>
            <MDBox mb={3} mt={3} sx={{ position: "center", overflowY: "scroll", maxHeight: "60%" }}>
              <Card>
                <MDBox
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="success"
                  mx={2}
                  mt={-3}
                  p={3}
                  mb={1}
                  textAlign="center"
                >
                  <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                    Update Message
                  </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                  <MDBox component="form" role="form">
                    <MDBox lineHeight={3} textAlign="left">
                      <MDTypography
                        display="block"
                        variant="caption"
                        color="text"
                        fontWeight="medium"
                      >
                        {getMessageType(selectedMessage?.message_type || "")}
                      </MDTypography>
                    </MDBox>
                    <br></br>
                    <MDBox mb={2}>
                      <MDInput
                        select
                        label="Channel"
                        variant="standard"
                        fullWidth
                        value={selectedMessage?.channel || ""}
                        onChange={(e) => {
                          setSelectedMessage({ ...selectedMessage, channel: e.target.value });
                        }}
                      >
                        {channelStatus === "loading" ? (
                          <MenuItem disabled>Loading...</MenuItem>
                        ) : channelStatus === "empty" ? (
                          <MenuItem disabled>No categories available</MenuItem>
                        ) : (
                          channels.map((channel) => (
                            <MenuItem key={channel.id} value={channel.id}>
                              {channel.name}
                            </MenuItem>
                          ))
                        )}
                      </MDInput>
                    </MDBox>
                    <MDBox mb={2}>
                      <MDInput
                        select
                        label="Category"
                        variant="standard"
                        fullWidth
                        value={selectedMessage?.category || ""}
                        onChange={(e) => {
                          setSelectedMessage({ ...selectedMessage, category: e.target.value });
                        }}
                      >
                        {categoryStatus === "loading" ? (
                          <MenuItem disabled>Loading...</MenuItem>
                        ) : categoryStatus === "empty" ? (
                          <MenuItem disabled>No categories available</MenuItem>
                        ) : (
                          categories.map((category) => (
                            <MenuItem key={category.pk} value={category.pk}>
                              {category.title}
                            </MenuItem>
                          ))
                        )}
                      </MDInput>
                    </MDBox>

                    {selectedMessage?.message_type === "singleproduct" ? (
                      <MDBox mb={2}>
                        <MDInput
                          type="number"
                          label="Regular Price"
                          variant="standard"
                          fullWidth
                          value={selectedMessage?.regular_price || ""}
                          onChange={(e) =>
                            setSelectedMessage({
                              ...selectedMessage,
                              regular_price: e.target.value,
                            })
                          }
                        />
                      </MDBox>
                    ) : null}
                    <MDBox mb={2}>
                      <MDInput
                        type="file"
                        name="uploaded_files"
                        variant="standard"
                        inputProps={{ multiple: true }}
                        fullWidth
                        onChange={handleFileChange}
                      />
                    </MDBox>
                    <MDBox mb={2}>
                      <MDInput
                        type="date"
                        label="Publish Date"
                        name="publish_date"
                        value={selectedMessage?.publish_date || ""}
                        variant="standard"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          min: formatDate(todayDate),
                          max: formatDate(tomorrowDate),
                        }}
                        onChange={(e) =>
                          setSelectedMessage({ ...selectedMessage, publish_date: e.target.value })
                        }
                      />
                    </MDBox>
                    <hr></hr>
                    <br></br>
                    {selectedMessage?.message_type === "singleproduct"
                      ? selectedMessage?.message_texts?.map((message, index) => (
                          <>
                            <MDBox mb={2}>
                              <MDInput
                                type="text"
                                label="Message Text"
                                variant="standard"
                                fullWidth
                                value={message.text || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].text = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="number"
                                label="Deal Price"
                                variant="standard"
                                fullWidth
                                value={message.deal_price || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].deal_price = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="number"
                                label="Discount (%)"
                                variant="standard"
                                fullWidth
                                value={message.discount || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].discount = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="text"
                                label="Currency"
                                variant="standard"
                                fullWidth
                                value={message.currency || "₹"}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].currency = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="url"
                                label="Link"
                                variant="standard"
                                fullWidth
                                value={message.link || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].link = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="text"
                                label="Sub ID"
                                variant="standard"
                                fullWidth
                                value={message.sub_id || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].sub_id = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                          </>
                        ))
                      : selectedMessage?.message_texts?.map((message, index) => (
                          <React.Fragment key={index}>
                            <MDBox mb={2}>
                              <MDInput
                                type="text"
                                label={`Message Text ${index + 1}`}
                                variant="standard"
                                fullWidth
                                value={message.text || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].text = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="number"
                                label="Deal Price"
                                variant="standard"
                                fullWidth
                                value={message.deal_price || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].deal_price = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="number"
                                label="Discount (%)"
                                variant="standard"
                                fullWidth
                                value={message.discount || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].discount = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="text"
                                label="Currency"
                                variant="standard"
                                fullWidth
                                value={message.currency || "₹"}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].currency = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="url"
                                label="Link"
                                variant="standard"
                                fullWidth
                                value={message.link || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].link = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                type="text"
                                label="Sub ID"
                                variant="standard"
                                fullWidth
                                value={message.sub_id || ""}
                                onChange={(e) => {
                                  const newMessages = [...selectedMessage.message_texts];
                                  newMessages[index].sub_id = e.target.value;
                                  setSelectedMessage({
                                    ...selectedMessage,
                                    message_texts: newMessages,
                                  });
                                }}
                              />
                            </MDBox>
                            <br></br>
                            <hr></hr>
                          </React.Fragment>
                        ))}
                    <MDBox mt={4} mb={1}>
                      <Grid container spacing={2} justifyContent="space-between">
                        <Grid item xs={4}>
                          <MDButton
                            variant="gradient"
                            color="info"
                            fullWidth
                            onClick={handleUpdateProduct}
                          >
                            Update
                          </MDButton>
                        </Grid>
                        <Grid item xs={4}>
                          <MDButton
                            variant="gradient"
                            color="error"
                            fullWidth
                            onClick={() => handleDeleteProduct(selectedMessage?.id)}
                          >
                            Delete
                          </MDButton>
                        </Grid>
                        <Grid item xs={4}>
                          <MDButton
                            variant="gradient"
                            color="light"
                            fullWidth
                            onClick={handleClose}
                          >
                            Close
                          </MDButton>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </Modal>
    </DashboardLayout>
  );
}

const messageType = {
  singleproduct: "Signle Product",
  multiple_products: "Multiple Products",
  categories: "Categories",
  custom_message: "Custom Message",
};
const getMessageType = (type) => messageType[type] || "default";

export default Tables;
